export default __webpack_public_path__ + "static/media/tree2.228cec2f.png";